/**
 * Select Component
 */
/* tslint:disable:no-submodule-imports */
import { getColorSchemeClassName } from '../../../styles/color-schemes';
import { bw6, getTextColorClassName } from '../../../styles/colors';
import './styles.scss';

import * as classNames from 'classnames';
import { find, isEqual } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import Select, { ReactSelectProps } from 'react-select';
import { autofill, Field } from 'redux-form';

import { IconArrowDown, IconX } from '../../../atoms/images/Icon';
import Label, { LabelProps, Span } from '../../../atoms/text/Label';
import SelectInput from './SelectInput';

interface IOwnDispatchProps {
  changeFieldValue: (field: string, value: any) => any;
}

export interface ISelectProps {
  className?: string;
  colorScheme?: 'light' | 'white';
  disabled?: boolean;
  form: string;
  label?: string;
  name: string;
  note?: string;
  optional?: boolean;
  options: ISelectStoreItem[];
  onUpdate?: (value: ISelectStoreItem | null) => void;
  updateOnMount?: boolean;
  selectName: string;
  selectProps?: ReactSelectProps;
  size?: TextFieldSize;
}

export type SelectReduxFormProps = ISelectProps & IOwnDispatchProps;

interface IOwnState {
  error?: string;
  selectValue?: ISelectStoreItem;
}

const classes = new BEM('select');

class SelectReduxForm extends React.Component<SelectReduxFormProps, IOwnState> {
  static defaultProps: Partial<SelectReduxFormProps> = {
    colorScheme: 'light',
    size: 'medium',
  };

  private input: Field;
  private initialValue: string | null;

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (this.initialValue && this.props.options.length) {
      const item = find(this.props.options, { value: this.initialValue }) || null;
      this.onChange(item, this.props.updateOnMount);
      this.initialValue = null;
    }
  }

  componentWillReceiveProps(nextProps: SelectReduxFormProps) {
    if (this.props.options.length && !isEqual(nextProps.options, this.props.options)) {
      this.onChange(null);
    } else if (nextProps.options.length && !this.props.options.length) {
      if (this.initialValue) {
        const item = find(nextProps.options, { value: this.initialValue }) || null;
        this.onChange(item);
        this.initialValue = null;
      }
    }
  }

  onSetInitialValue = (value: string) => {
    this.initialValue = value;
  }

  onChange = (item: ISelectStoreItem | null, shouldUpdate = true) => {
    const {
      changeFieldValue,
      onUpdate,
    } = this.props;

    const input = this.input.getRenderedComponent() as SelectInput;
    const name = input.props.input.name;

    this.setState({ selectValue: item || undefined });

    changeFieldValue(name, item ? item.value : '');

    if (onUpdate && shouldUpdate) {
      onUpdate(item);
    }
  }

  onError = (error?: string) => {
    this.setState({ error });
  }

  renderSelectArrow = (props: any) => {
    const iconProps = props.isOpen ? {
      style: {
        top: 2,
        transform: 'scaleY(-1)',
      },
      className: getTextColorClassName(bw6),
    } : this.props.disabled ? {
      style: { display: 'none' },
    } : {};
    return <IconArrowDown {...iconProps} />;
  }

  render() {
    const {
      className,
      colorScheme,
      disabled,
      label,
      name,
      note,
      optional,
      options,
      selectName,
      selectProps,
      size,
    } = this.props;

    const {
      error,
      selectValue,
    } = this.state;

    const modifiers = {
      'is-disabled': !!disabled,
      'error': !!error,
      [size!]: true,
    };

    const extraClasses = classNames(
      colorScheme && getColorSchemeClassName(colorScheme, 'select'),
      className,
    );

    const renderers = {
      arrowRenderer: this.renderSelectArrow,
      clearRenderer: () => <IconX />,
    };

    let noteLabel: JSX.Element | null = null;
    if (note || optional != null) {
      const noteProps: LabelProps = {
        size: 'small',
        variant: 'note',
        ...classes('note'),
      };
      noteLabel = <Label {...noteProps}>{note || 'Optional'}</Label>;
    }

    const labelClasses = new BEM('label');

    return (
      <div {...classes('', modifiers, extraClasses) }>
        {label && <Label text={label} size="small" htmlFor={selectName} {...classes('label') } />}
        {noteLabel}
        <Field
          ref={(node) => this.input = node!}
          component={SelectInput}
          name={name}
          props={{
            setInitialValue: this.onSetInitialValue,
            onError: this.onError,
          }}
          withRef
        />
        <Select
          disabled={disabled}
          name={selectName}
          options={options}
          onChange={this.onChange}
          value={selectValue}
          {...renderers}
          {...selectProps}
        />
        {error && (
          <Span {...labelClasses('', 'error') } size="medium" textColor="dangerous">{error}</Span>
        )}
      </div>
    );
  }
}

const ConnectedSelectReduxForm = connect(null,
  (dispatch, { form }: ISelectProps): IOwnDispatchProps => ({
    changeFieldValue: (field: string, value: any) => dispatch(autofill(form, field, value)),
  }),
)(SelectReduxForm);

export default ConnectedSelectReduxForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/Select/index.tsx